import { render } from "./ReferidosSegundoNivel.vue?vue&type=template&id=22d31b2a&scoped=true"
import script from "./ReferidosSegundoNivel.vue?vue&type=script&lang=js"
export * from "./ReferidosSegundoNivel.vue?vue&type=script&lang=js"

import "./ReferidosSegundoNivel.vue?vue&type=style&index=0&id=22d31b2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d31b2a"]])

export default __exports__